import { render, staticRenderFns } from "./CurrentInsuranceDetails.vue?vue&type=template&id=986f4d74"
import script from "./CurrentInsuranceDetails.vue?vue&type=script&lang=js"
export * from "./CurrentInsuranceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports